import { motion } from "framer-motion";
import NextArrow from "@/components/landing/NextArrow";
import { Landmark, Gavel, Users, ShieldCheck } from "lucide-react";

const stats = [
  { icon: Gavel, value: "+20", label: "Años de práctica litigiosa" },
  { icon: Landmark, value: "Poder Judicial", label: "Experiencia dentro del sistema de justicia" },
  { icon: Users, value: "Cientos", label: "De asuntos atendidos en materias diversas" },
  { icon: ShieldCheck, value: "100%", label: "Seguimiento digital de cada expediente" },
];

const Experience = () => (
  <section id="trayectoria" className="screen py-16 md:py-20 bg-[var(--gm-surface)] overflow-hidden" data-testid="experience-section">
    <div className="noise-overlay" />
    <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-10 items-start">
      <div className="lg:col-span-5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-xs tracking-[0.3em] uppercase font-semibold text-[var(--gm-accent)] mb-6">Trayectoria</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight">
            Dos décadas entre estrados, <span className="italic text-[var(--gm-accent)]">del otro lado del escritorio</span>
          </h2>
          <p className="mt-5 text-base font-light text-[var(--gm-muted)] leading-relaxed">
            Haber servido dentro del Poder Judicial otorga una perspectiva que pocos litigantes poseen:
            conocer cómo se estudian, valoran y resuelven los asuntos desde adentro. Esa visión, sumada a
            más de veinte años de práctica en materias civil, mercantil, penal y laboral, se traduce en
            estrategias realistas y resultados medibles para cada cliente.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="img-frame rounded-sm mt-6 shadow-[0_30px_60px_rgba(11,22,44,0.15)]"
        >
          <img
            src="/images/experience.jpg"
            alt="Oficina privada del despacho con biblioteca jurídica"
            className="w-full h-40 xl:h-48 object-cover"
            data-testid="experience-image"
          />
        </motion.div>
      </div>

      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="bg-[var(--gm-paper)] border border-black/5 rounded-sm p-6 xl:p-8 shadow-[4px_4px_10px_rgba(11,22,44,0.05),-4px_-4px_10px_rgba(255,255,255,0.8)]"
            data-testid={`experience-stat-${i}`}
          >
            <s.icon className="w-6 h-6 text-[var(--gm-accent)] mb-4" strokeWidth={1.5} />
            <p className="font-serif-display text-3xl md:text-4xl font-medium tracking-tight">{s.value}</p>
            <p className="mt-3 text-sm font-light text-[var(--gm-muted)] leading-relaxed">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
        <NextArrow to="semblanza" />
</section>
);

export default Experience;
